import { t } from 'i18next';

export const getTextFromDocumentStatus = (status, document) => {
  if (status === 'NotSigned' || status === 'PartiallySigned') {
    return !document.isRead ? t('ReadBeforeSigning') : t('Read');
  }

  if (status === 'Signed') {
    const signed = t('Signed');

    return signed.charAt(0).toUpperCase() + signed.slice(1).toLowerCase();
  }

  if (status === 'Archived') {
    return t('Archived');
  }

  if (status === 'Expired') {
    return t('AgreementExpired');
  }

  if (status === 'Cancelled') {
    return t('AgreementCancelled');
  }

  if (status === 'CancelledBySignatory') {
    return t('AgreementRejected');
  }

  if (status === 'Manual') {
    return t('AgreementManual');
  }

  if (status === 'SignedByCurrentContractingParty') {
    return t('AgreementAwaitingOtherContractingParty');
  }
};
